// ============================================
// CLIPBOARD UTILITIES
// ============================================

import { getSurveyRegisterUrl } from '../services/api';

type ToastCallback = (type: 'success' | 'error', title: string, message: string) => void;

/**
 * Copy survey registration link to clipboard
 * @param instanceId - The survey instance ID
 * @param onShowToast - Toast callback for success/error messages
 */
export function copyRegisterLink(instanceId: string, onShowToast: ToastCallback): void {
    try {
        const url = getSurveyRegisterUrl(instanceId);
        navigator.clipboard.writeText(url);
        onShowToast('success', 'הקישור הועתק', 'הקישור להרשמה הועתק ללוח בהצלחה');
    } catch {
        onShowToast('error', 'שגיאה בהעתקה', 'לא ניתן היה להעתיק את הקישור');
    }
}
